import { z } from "zod";
const ulid = z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/i);
import { showcaseShotScaleSchema, showcasePalettePhaseSchema } from "./story.js";
/** Editor decisions, not generated output or an approval. */
export const storyPictureSceneSchema = z
    .object({
    composition: z.string().trim().min(1).max(2000),
    emotionalBeat: z.string().trim().min(1).max(500),
    gesture: z.string().trim().min(1).max(500),
    imageOnlyInformation: z.string().trim().min(1).max(1000),
    motif: z.string().trim().min(1).max(300),
    storyTime: z.string().trim().min(1).max(300),
    characterPositions: z.string().trim().min(1).max(500),
    forbiddenVisibleElements: z.array(z.string().trim().min(1).max(500)).min(1).max(30),
    layoutArchetype: z.enum([
        "FULL_BLEED",
        "VIGNETTE",
        "INTEGRATED_NEGATIVE_SPACE",
        "FACING_PAGE",
        "SPOT_ART",
        "QUIET_BEAT",
    ]),
    shotScale: showcaseShotScaleSchema,
    palettePhase: showcasePalettePhaseSchema,
    lines: z.array(z.string().trim().min(1).max(160)).min(1).max(4),
})
    .strict();
export const saveStoryPicturePlanCommandSchema = z
    .object({
    kind: z.literal("PAGE_PLAN"),
    expectedRevision: z.number().int().nonnegative(),
    expectedIntentRevision: z.number().int().positive(),
    expectedVisualRevision: z.number().int().positive(),
    sourceArtifactId: ulid,
    previousStoryboardArtifactId: ulid.nullable(),
    // Eight scenes, or a picture book's twelve (review P1, 2026-11-03): one per page of words.
    scenes: z
        .array(storyPictureSceneSchema)
        .min(8)
        .max(12)
        .refine((scenes) => scenes.length === 8 || scenes.length === 12, {
        message: "A picture plan has eight scenes, or a picture book's twelve.",
    }),
    coverTitleLines: z.array(z.string().trim().min(1).max(100)).min(1).max(3),
    reviewedStoryOrder: z.literal(true),
})
    .strict();
//# sourceMappingURL=story-picture-plan.js.map